import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { RestartOperation } from 'src/app/perical/models/thermal-operation.model';

export interface RestartOperationForm {
  totalTimeToOpenChoke: number;
  initialTimeToOpenChoke: number;
  terminalChokeOpenPercent: number;
  initialChokeOpenPercent: number;
  allowTransientFlow: boolean;
}

@Component({
  selector: 'app-restart-operation',
  templateUrl: './restart-operation.component.html',
  providers: subformComponentProviders(RestartOperationComponent),
  standalone: false
})
export class RestartOperationComponent implements AfterViewInit, OnChanges {
  public control(name: string): UntypedFormControl {
    return this.form.formGroup.get(name) as UntypedFormControl;
  }

  @Input()
  public disableRestartOperation: boolean;
  public timeUnits: any[];

  public form = createForm<RestartOperation>(this, {
    formType: FormType.SUB,
    formControls: {
      totalTimeToOpenChoke: new UntypedFormControl(null, { updateOn: 'blur', validators: [Validators.min(0)] }),
      initialTimeToOpenChoke: new UntypedFormControl(1, { updateOn: 'blur', validators: [Validators.min(0)] }),
      terminalChokeOpenPercent: new UntypedFormControl(50, { updateOn: 'blur', validators: [Validators.min(0), Validators.max(100)] }),
      initialChokeOpenPercent: new UntypedFormControl(5, { updateOn: 'blur', validators: [Validators.min(0)] }),
      allowTransientFlow: new UntypedFormControl(false)
    }
  });

  ngAfterViewInit(): void {
    this.enableDisable();

    if (!this.form.formGroup.controls.totalTimeToOpenChoke.value) {
      this.form.formGroup.controls.totalTimeToOpenChoke.setValue(10);
    }

    this.updateInitialCokeOpenValidation();
    this.updateInitialTimeToOpenValidation();
  }

  ngOnChanges(): void {
    this.enableDisable();
  }

  private enableDisable() {
    const controlNames = [
      'totalTimeToOpenChoke',
      'initialTimeToOpenChoke',
      'terminalChokeOpenPercent',
      'initialChokeOpenPercent',
      'allowTransientFlow'
    ];
    
    controlNames.forEach(controlName => {
      const control = this.form.formGroup.controls[controlName];
      if (this.disableRestartOperation) {
        control.disable({ emitEvent: false });
      } else {
        control.enable({ emitEvent: false });
      }
    });
  }

  public updateInitialCokeOpenValidation() {
    this.form.formGroup.controls.initialChokeOpenPercent.setValidators([Validators.max(this.form.formGroup.controls.terminalChokeOpenPercent.value)]);
    this.form.formGroup.controls.initialChokeOpenPercent.updateValueAndValidity({ emitEvent: false });
    this.form.formGroup.controls.terminalChokeOpenPercent.updateValueAndValidity({ emitEvent: false });
  }

  public updateInitialTimeToOpenValidation() {
    this.form.formGroup.controls.initialTimeToOpenChoke.setValidators([Validators.max(this.form.formGroup.controls.totalTimeToOpenChoke.value)]);
    this.form.formGroup.controls.initialTimeToOpenChoke.updateValueAndValidity({ emitEvent: false });
    this.form.formGroup.controls.terminalChokeOpenPercent.updateValueAndValidity({ emitEvent: false });
  }
}
